import { combineReducers } from 'redux';

import shareVideo from 'js/src/data/share-video';

export const getRootReducer = () => {
    return combineReducers({
        shareVideo,
    });
};
